export const SessionSettingsTestIds = {
  deviceList: 'device_list',
  deviceListCard: 'device_list_card'
} as const;
